import { useList } from '@refinedev/core';

type RemoteDocsConnection = {
  id: string;
  status: 'ACTIVE' | 'REVOKED' | 'PENDING';
  createdAt: string;
};

export const useRemoteDocsConnections = () => {
  const { data, isLoading, isError } = useList<RemoteDocsConnection>({
    resource: 'remote-docs-connections',
  });

  const getLatestActiveConnection = () => {
    if (data?.data) {
      const activeConnections = data.data.filter(connection => connection.status === 'ACTIVE');
      activeConnections.sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );
      return activeConnections[0] || null;
    }
    return null;
  };

  return {
    connections: data?.data,
    latestActiveConnection: getLatestActiveConnection(),
    isLoading,
    isError,
  };
};
